import React from 'react'

const ArrorRight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 20 20" {...props}>
    <path fillRule="evenodd" d="M9.807 16.402c-.314-.337-.295-.864.041-1.178l4.704-4.39H3.334c-.46 0-.833-.374-.833-.834 0-.46.373-.833.833-.833h11.22L9.848 4.776c-.336-.314-.355-.841-.04-1.178.313-.336.84-.355 1.177-.04l6.25 5.833c.17.157.265.378.265.609 0 .231-.096.452-.265.61l-6.25 5.833c-.336.314-.864.295-1.178-.041z" clipRule="evenodd"/>
  </svg>
)

export default ArrorRight
